<template>
	<section class="view-venue-description" v-if="venueModel.getDescription()">
		<p>{{ venueModel.getDescription() }}</p>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * Displays the venue description text.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Venue
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewVenueDescription extends ViewBase {
		/**
		 * The venue model containing description data
		 *
		 * @type ChalkySticks.Model.Venue
		 */
		@Prop({
			default: () => ChalkySticks.Factory.Venue.model(),
		})
		public venueModel!: ChalkySticks.Model.Venue;
	}
</script>

<style lang="scss">
	.view-venue-description {
		color: var(--chalky-white);
		padding: 2rem var(--padding);
		text-align: center;
	}
</style>
